export const ACTIVE_RESORT_STORAGE_KEY = 'elda:activeResortId'

// Le montage carte habille le selecteur d une pastille porteuse d une icone :
// `empty:hidden` ne peut donc pas la replier, il lui faut la MEME regle que le
// composant. Une seule definition, sinon les deux divergent.
export const hasResortChoice = resortIds =>
  Array.isArray(resortIds) && resortIds.length > 1

// Doit refuser EXACTEMENT ce que refuse toResortId (back, middleware/resortScope.js) :
// une valeur acceptee ici mais refusee la-bas part en en-tete et rend 400 tout l app.
const MAX_INT4 = 2147483647

// Number(null) vaut 0 et Number('abc') vaut NaN : le garde couvre « rien de
// stocke » et « valeur corrompue » d'un coup.
export function getActiveResortId() {
  try {
    const n = Number(localStorage.getItem(ACTIVE_RESORT_STORAGE_KEY))
    return Number.isInteger(n) && n > 0 && n <= MAX_INT4 ? n : null
  } catch {
    return null
  }
}

export function setActiveResortId(id) {
  try {
    localStorage.setItem(ACTIVE_RESORT_STORAGE_KEY, String(id))
  } catch (e) {
    console.warn('Could not persist active resort', e)
  }
}

// Basculer, c est DEUX ecritures : la cle ci-dessus, et le resort_id de
// l utilisateur persiste, qui en est le miroir (38 lecteurs passent par le
// contexte, 49 par ce payload). N en faire qu une les fait diverger — chaque
// appelant qui bascule doit passer par ici.
const USER_STORAGE_KEY = 'user'

export function switchActiveResort(id) {
  setActiveResortId(id)
  try {
    const stored = JSON.parse(localStorage.getItem(USER_STORAGE_KEY))
    if (!stored?.user) return
    stored.user.resort_id = id
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(stored))
  } catch {
    /* payload absent ou corrompu : le bootstrap le reecrira */
  }
}

export function clearActiveResortId() {
  try {
    localStorage.removeItem(ACTIVE_RESORT_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
